import { enumMembers } from "../../../api/apiSchema";
import type { WorkflowEventPayload } from "../../../api/threads/liveMessages";

type WorkflowEventKind = WorkflowEventPayload["event"];

/** Every Workflow event the server records: a new kind doesn't compile until it is listed here, and then needs its words. */
export const WORKFLOW_EVENT_KINDS = enumMembers<WorkflowEventKind>({ started: true, skipped: true, left: true, resumed: true, completed: true, run_to: true });

/** Words for events that read differently by who wrote them or what they name. */
export const WORKFLOW_EVENT_VARIANTS = ["skippedOnTheWay", "runToStopped", "switched", "switchedUnsettled"] as const;

/**
 * The key of a Workflow event's line in the log (`threads.events.workflow.*`): a skip the runner
 * recorded on the way to a run's step reads apart from a person's (PC-4), a run to no step
 * is the run stopped, and a Workflow started where another was followed is a switch (F126),
 * after the furthest step of it that settled, where one did.
 */
export function workflowEventKey(payload: WorkflowEventPayload, byRunner: boolean): WorkflowEventKind | (typeof WORKFLOW_EVENT_VARIANTS)[number] {
  if (payload.event === "skipped" && byRunner) return "skippedOnTheWay";
  if (payload.event === "run_to" && payload.step_key === null) return "runToStopped";
  if (payload.event === "started" && payload.from_workflow !== undefined && payload.from_workflow !== null) {
    return payload.after_step === undefined || payload.after_step === null ? "switchedUnsettled" : "switched";
  }
  return payload.event;
}
